export default Vue => {
  Vue.component("v-fagforening-for-mig", () =>
    import("./v-fagforening-for-mig.vue")
  );
};
